export const PROVIDER_BADGE_COLORS = [
  '#6C00CC',
  '#D46D27',
  '#2563EB',
  '#059669',
  '#DB2777',
] as const;

const normalizeProviderName = (name: string | null | undefined): string =>
  name?.trim().replace(/\s+/g, ' ').toLowerCase() ?? '';

export const getProviderBadgeColor = (name: string | null | undefined): string => {
  const cleanName = normalizeProviderName(name);
  if (!cleanName) return PROVIDER_BADGE_COLORS[0];

  let hash = 0x811c9dc5;
  for (let index = 0; index < cleanName.length; index += 1) {
    hash ^= cleanName.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  hash = ((hash << 13) | (hash >>> 19)) >>> 0;
  hash = Math.imul(hash, 0x5bd1e995);
  hash = ((hash << 15) | (hash >>> 17)) >>> 0;

  return PROVIDER_BADGE_COLORS[hash % PROVIDER_BADGE_COLORS.length];
};

export const getProviderInitials = (name: string | null | undefined): string =>
  (name ?? '')
    .replace(/^(Dr|Mr|Mrs|Ms|Mx)\.?\s+/i, '')
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || '--';
